import { render, staticRenderFns } from "./ToggleReviewForm.vue?vue&type=template&id=aa268904&scoped=true&"
import script from "./ToggleReviewForm.vue?vue&type=script&lang=js&"
export * from "./ToggleReviewForm.vue?vue&type=script&lang=js&"
import style0 from "./ToggleReviewForm.vue?vue&type=style&index=0&id=aa268904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa268904",
  null
  
)

export default component.exports